import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { CardTitle } from 'material-ui/Card'
import FlatButton from 'material-ui/FlatButton'
import {
  Table,
  TableHeader,
  TableRow,
  TableHeaderColumn,
  TableBody,
  TableRowColumn,
  TableFooter
} from 'material-ui/Table'
import ArrowLeft from 'material-ui/svg-icons/hardware/keyboard-arrow-left'
import ArrowRight from 'material-ui/svg-icons/hardware/keyboard-arrow-right'
import api from '../../api'
import { setSnackbarMessage } from '../../actions/snackbar'
import Create from './create'
import _ from 'lodash'
import { Link } from 'react-router'

const styles = {
  cardTitle: {
    paddingLeft: '0px'
  },
  actionsColumn: {
    width: 90
  },
  table: {
    paddingTop: '2em'
  }
}

const getColumnStyle = (col) => {
  const style = {}
  if (col.prop === 'id') {
// @ts-ignore
    style.width = 45
  }
  return style
}

class Associations extends Component<any, any> {
  constructor (props) {
    super()
    const order = props.queryOrder
      ? props.queryOrder
      : [
        {
          column: 'created_at',
          direction: 'desc'
        }
      ]

    this.state = {
      associatedRecords: {},
      joinRecords: [],
      references: {},
      query: {
        offset: 0,
        limit: 10,
        order
      },
      totalCount: 0,
      sortFunction: props.sortFunction,
      createKey: 0
    }
  }

  componentWillMount () {
    this.populateList()
  }

  setQuery (changes) {
    const changedQuery = Object.assign({}, this.state.query, changes)

    this.setState({
      query: changedQuery
    })

    this.populateList(changedQuery)
  }

  handlePrevPage () {
    this.setQuery({
      offset: Math.max(
        0,
        parseInt(this.state.query.offset, 10) -
          parseInt(this.state.query.limit, 10)
      )
    })
  }

  handleNextPage () {
    this.setQuery({
      offset:
        parseInt(this.state.query.offset, 10) +
        parseInt(this.state.query.limit, 10)
    })
  }

  loadJoinRecords (query) {
    const pageFilters = {
      offset: query.offset,
      limit: query.limit,
      order: query.order
    }
    const body = Object.assign({}, this.props.joinApiQuery, pageFilters)

    return api
      .get(this.props.joinApiPath, { body })
      .then((res) => {
        const totalCount = parseInt(res.headers.get('x-total-count'), 10)

        if (totalCount !== this.state.totalCount) {
          this.setState({ totalCount: totalCount })
        }
        return res.json()
      })
      .then((data) => {
        this.setState({ joinRecords: data })
        return data
      })
  }

  populateList (query = this.state.query) {
    this.loadJoinRecords(query)
      .then((joinRecords) => this.loadAssociatedRecords(joinRecords))
      .then((associatedRecords) => this.loadReferences(associatedRecords))
  }

  loadAssociatedRecords (joinRecords) {
    const ids = joinRecords.map(
      (record) => record[this.props.associationIdField]
    )
    const uniqIds = _(ids).uniq().value()

    if (uniqIds.length) {
      const body = {
        filters: {
          ids: uniqIds
        }
      }

      return api
        .get(this.props.associationApiPath, { body })
        .then((res) => res.json())
        .then((data) =>
          data.reduce((prev, curr) => {
            return { ...prev, [curr.id]: curr }
          }, {})
        )
        .then((data) => {
          this.setState({
            associatedRecords: Object.assign(
              {},
              this.state.associatedRecords,
              data
            )
          })
          return data
        })
    } else {
      return []
    }
  }

  loadReferences (records) {
    this.props.columns.forEach((column) => {
      if (column.references) {
        const referenceIds = _(records)
          .values()
          .map(column.prop)
          .compact()
          .uniq()
          .value()

        if (referenceIds.length) {
          const body = {
            filters: {
              ids: referenceIds
            }
          }

          api
            .get(column.references, { body })
            .then((res) => res.json())
            .then((data) => {
              this.setState((prevState) => ({
                ...prevState,
                references: {
                  ...prevState.references,
                  [column.prop]: data
                }
              }))
            })
        }
      }
    })
  }

  handleAssociationCreated () {
    this.setQuery({ offset: 0 })
  }

  handleDelete ({ id }) {
    api.del(`${this.props.joinApiPath}/${id}`).then((res) => {
      if (res.ok) {
        this.populateList()
        // Increment createKey to force Create component to remount and reset
        this.setState({ createKey: this.state.createKey + 1 })
        this.props.setSnackbarMessage(`Successfully delete #${id}`)
      } else {
        this.props.setSnackbarMessage(`Unable to delete #${id}`)
      }
    })
  }

  render () {
    const { joinRecords, associatedRecords, references, totalCount } =
      this.state
    const offset = parseInt(this.state.query.offset, 10)
    const limit = parseInt(this.state.query.limit, 10)
    const showPrevPage = offset > 0
    const showNextPage = totalCount > offset + limit
    const associationIdField = this.props.associationIdField

    if (this.state.sortFunction) {
      joinRecords.sort(
        this.state.sortFunction(associationIdField, associatedRecords)
      )
    }

    return (
      <div>
        <CardTitle title={this.props.title} style={styles.cardTitle} />

        <Create
          key={this.state.createKey}
          fields={this.props.fields}
          apiPath={this.props.joinApiPath}
          handleAssociationCreated={this.handleAssociationCreated.bind(this)}
          baseRecord={this.props.baseRecord}
          associatedRecords={this.state.associatedRecords}
          joinRecords={this.state.joinRecords}
        />

        {this.props.tableHeaderSlot && (
          <div style={{ marginTop: 14 }}>
            {this.props.tableHeaderSlot}
          </div>
        )}

        <Table style={styles.table}>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              {this.props.columns.map((col) => {
                return (
                  <TableHeaderColumn key={col.prop} style={getColumnStyle(col)}>
                    {col.name}
                  </TableHeaderColumn>
                )
              })}
              <TableHeaderColumn style={styles.actionsColumn} />
              {this.props.customActions &&
                this.props.customActions.map((customAction, i) => (
                  <TableHeaderColumn key={`custom-action-${i}`} />
                ))}
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {joinRecords.map((joinRecord) => {
              const id = joinRecord[associationIdField]
              const associatedRecord = associatedRecords[id] || {}

              return (
                <TableRow key={joinRecord.id}>
                  {this.props.columns.map((col) => {
                    let value = associatedRecord[col.prop]
                    if (col.references) {
                      const reference = _.find(references[col.prop], {
                        id: value
                      })
                      if (reference) {
                        value = reference[col.displayProp]
                      }
                    }

                    return (
                      <TableRowColumn
                        key={col.prop}
                        style={getColumnStyle(col)}
                      >
                        {`${value}`}
                      </TableRowColumn>
                    )
                  })}
                  {this.props.viewAssociation && (
                    <TableRowColumn style={styles.actionsColumn}>
                      <Link to={this.props.viewAssociation(joinRecord)}>
                        <FlatButton label='View' secondary />
                      </Link>
                    </TableRowColumn>
                  )}
                  <TableRowColumn style={styles.actionsColumn}>
                    <FlatButton
                      label='Delete'
                      secondary
                      onClick={() => this.handleDelete(joinRecord)}
                    />
                  </TableRowColumn>
                  {this.props.customActions &&
                    this.props.customActions.map((customAction, i) => (
                      <TableRowColumn style={styles.actionsColumn} key={i}>
                        <FlatButton
                          label={customAction.label}
                          secondary
                          onClick={() =>
                            customAction.handlePress(
                              joinRecord,
                              this.state,
                              this.setState.bind(this)
                            )
                          }
                        />
                      </TableRowColumn>
                    ))}
                </TableRow>
              )
            })}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TableRowColumn style={{ textAlign: 'right', paddingRight: 0 }}>
                <FlatButton
                  onClick={this.handlePrevPage.bind(this)}
                  icon={<ArrowLeft />}
                  disabled={!showPrevPage}
                />
                <FlatButton
                  onClick={this.handleNextPage.bind(this)}
                  icon={<ArrowRight />}
                  disabled={!showNextPage}
                />
              </TableRowColumn>
            </TableRow>
          </TableFooter>
        </Table>
      </div>
    )
  }
}

// @ts-ignore
Associations.propTypes = {
  title: PropTypes.string.isRequired,
  fields: PropTypes.array.isRequired,
  joinApiPath: PropTypes.string.isRequired,
  associationApiPath: PropTypes.string.isRequired,
  baseRecord: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func
  ]).isRequired,
  columns: PropTypes.array.isRequired,
  associationIdField: PropTypes.string.isRequired,
  viewAssociation: PropTypes.func,
  queryOrder: PropTypes.array
}

// @ts-ignore
Associations.defaultProps = {
  baseRecord: {}
}

export default connect(null, { setSnackbarMessage })(Associations)
